import { CommonModule } from '@angular/common';
import { Component, computed, Injector, input, OnInit, output, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { TextSearchComponent } from '../../../../../../shared/components/forms/text-search/text-search.component';
import { AnimateOpenDirective } from '../../../../../../shared/directives/animate-open.directive';
import { templateDrivenFormsViewProviders } from '../../../../../../shared/directives/form.directive';
import { doesFormPassValidations } from '../../pipes/form-validation.pipe';

@Component({
  selector: 'app-model-number-capture',
  standalone: true,
  imports: [FormsModule, CommonModule, AnimateOpenDirective, TextSearchComponent],
  templateUrl: './model-number-capture.component.html',
  styleUrl: './model-number-capture.component.scss',
  viewProviders: [templateDrivenFormsViewProviders],
})
export class ModelNumberCaptureComponent implements OnInit {
  panelExpanded = signal(false);

  formValue = input.required<Record<string, any>>();
  submittingValue = input.required<boolean>();
  formSubmitted = input.required<boolean>();
  formValid = output<boolean>();
  loadingData = output<boolean>();
  activeStep = input.required<any>();
  productDescription = input.required<string>();
  valid = signal(false);
  errors = signal<string[]>([]);

  private viewModel = computed(() => {
    return {
      panelExpanded: this.panelExpanded(),
      submittingValue: this.submittingValue(),
      formValue: this.formValue(),
      brandImage: '',
      activeStep: this.activeStep(),
      formSubmitted: this.formSubmitted(),
      valid: this.valid(),
      errors: this.errors(),
      productDescription: this.productDescription(),
    };
  });

  get vm() {
    return this.viewModel();
  }

  constructor(private readonly injector: Injector) {}

  ngOnInit(): void {
    this.validateForm();
  }

  validateForm(): void {
    toObservable(this.formValue, { injector: this.injector })
      .pipe(doesFormPassValidations(this.vm.activeStep, { debounceTimer: 100 }))
      .subscribe({
        next: ({ valid, errors }) => {
          this.valid.set(valid);
          this.errors.set(errors);
          this.formValid.emit(valid);
        },
      });
  }
}
